__turbopack_context__.v({
  "addPositionButton": "positionsTable-module-scss-module__FdaV0a__addPositionButton",
  "checkedCell": "positionsTable-module-scss-module__FdaV0a__checkedCell",
  "checkedRow": "positionsTable-module-scss-module__FdaV0a__checkedRow",
  "deleteButton": "positionsTable-module-scss-module__FdaV0a__deleteButton",
  "deleteIcon": "positionsTable-module-scss-module__FdaV0a__deleteIcon",
  "emptyMessage": "positionsTable-module-scss-module__FdaV0a__emptyMessage",
  "emptyWrapper": "positionsTable-module-scss-module__FdaV0a__emptyWrapper",
  "headerRow": "positionsTable-module-scss-module__FdaV0a__headerRow",
  "headerRowLeft": "positionsTable-module-scss-module__FdaV0a__headerRowLeft",
  "headerRowRight": "positionsTable-module-scss-module__FdaV0a__headerRowRight",
  "hoveredRow": "positionsTable-module-scss-module__FdaV0a__hoveredRow",
  "liveBondCell": "positionsTable-module-scss-module__FdaV0a__liveBondCell",
  "searchInputWrapper": "positionsTable-module-scss-module__FdaV0a__searchInputWrapper",
  "tableWrapper": "positionsTable-module-scss-module__FdaV0a__tableWrapper",
  "wrapper": "positionsTable-module-scss-module__FdaV0a__wrapper",
});
